<template>
  <div class="classify">
    <el-container>
      <el-header>
        <el-form :inline="true" :model="dataForm" label-width="100px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="公文分类：">
                <el-input v-model="dataForm.name" placeholder="请输入标题" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16" class="btnRight">
              <el-form-item class="btnList">
                <el-button type="primary" @click="query()">查 询</el-button>
                <el-button type="info" @click="reset()">重 置</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row>
          <el-col :span="24">
            <div class="operatePanel">
              <el-button
                  type="primary"
                  icon="el-icon-plus"
                  @click="setIsShowDialog(true, 1)"
              >新建</el-button>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main ref="main">
        <div>
          <el-table
              ref="dataTable"
              :data="documentList"
              highlight-current-row
              @current-change="handleSelectionChange"
              @row-click="rowClicked"
              size="mini"
              border
          >
            <el-table-column
                prop="name"
                label="公文分类"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="descript"
                label="描述"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="createTime"
                label="创建时间"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="操作" header-align="center" align="center" width="180">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="setIsShowDialog(true, 3, scope.row.id)">详情</el-button>
                <el-button type="text" size="small" @click="setIsShowDialog(true, 2, scope.row.id)">修改</el-button>
                <el-button type="text" size="small" @click="deleteClassify(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-main>
      <el-footer>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="dataForm.pageIndex"
                :page-sizes="[10, 20, 30, 50, 100]"
                :page-size="dataForm.pageSize"
                layout="total, prev, pager, next, sizes, jumper"
                :total="total"
        ></el-pagination>
      </el-footer>

      <addAndModiify
          v-if="isShowDialog"
          :isShowDialog="isShowDialog"
          :systemFileTypeId="systemFileTypeId"
          :classiftType="classiftType"
          @setIsShowDialog="setIsShowDialog"></addAndModiify>
    </el-container>
  </div>
</template>

<script>
import addAndModiify from './addAndModiify'
import {
  getTypeListService,
  deleteFileTypeService,
} from '@/services/documentServices'

export default {
  name: "index",
  data(){
    return {
      dataForm: {
        name: '',
        pageIndex: 1,
        pageSize: 10,
      },
      documentList: [],
      total: 0,

      isShowDialog: false,
      classiftType: 0,
      systemFileTypeId: null,
    }
  },
  components: {
    addAndModiify
  },
  methods: {
    onActive(menuCode) {
      // this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.getTypeList();
    },
    //查询列表
    getTypeList(){
      let paramsData = {
        ...this.dataForm
      }
      getTypeListService(paramsData).then( res => {
        if(res.code == 10000000){
          console.log(res)
          this.documentList = res.data;
          this.total = res.total;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },

    //根据条件查询
    query(){
      this.getTypeList();
    },
    //重置数据
    reset(){
      this.dataForm = {
        name: '',
        pageIndex: 1,
        pageSize: 10,
      };
      this.documentList = [];
      this.getTypeList();
    },
    //设置弹窗
    setIsShowDialog(val, type, id = null){
      if(val){
        this.classiftType = type
        this.systemFileTypeId = id
      }else{
        this.getTypeList();
      }
      this.isShowDialog = val;
    },
    deleteClassify(id){
      this.$confirm('此操作将永久删除该分类, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let paramsData = {
          systemFileTypeId: id
        }
        deleteFileTypeService(paramsData).then( res => {
          if(res.code == 10000000){
            this.$message({
              type: 'success',
              message: '删除成功！'
            });
            this.getTypeList();
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error => {
          this.$message.error("网络请求失败");
        });
      }).catch(() => {
        this.$message({
          type: 'success',
          message: '已取消删除！'
        });
      });
    },

    // 列代表多选回调
    handleSelectionChange(val) {
      this.selectItems = val;
    },
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.dataTable.toggleRowSelection(row);
    },
    // 分页改变事件
    handleCurrentChange(page) {
      this.dataForm.pageIndex = page;
      this.query();
    },
    // 分页显示数量改变事件
    handleSizeChange(rows) {
      this.dataForm.pageIndex = 1;
      this.dataForm.pageSize = rows;
      this.query();
    },
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/css/commonLayout.scss";
  .classify{
    height: 100%;
    background-color: white;
  }
  .btnRight {
    display: flex;
    justify-content: flex-end;
    .btnList{
      text-align: right;
    }
    /deep/.el-form-item__content{
      height: auto;
    }
  }
</style>
